import React from 'react';

export default function CloseIcon(props) {
  return (
    <svg width={props.width || "14"} height={props.height || "14"} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13 1L1 13M1 1L13 13" stroke={props.fill || "#3B454F"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
